import { ApiResponseError } from '@gk/gk-modules';
import { Observable, throwError } from 'rxjs';

export const handleApiError = (err: ApiResponseError): Observable<never> => {
  console.error(err);
  return throwError(() => err);
};
